const zhCN = {
  changePassword: '修改密码',

  usernameTxt: '账户名',
  usernameBlank: '请输入帐户名！',
  usernameVaildFail: '用户名校验失败',

  passwordTxt: '密码',
  passwordBlank: '请输入 8-16 位密码，区分大小写！',
  
  passwordStrength: '密码强度',
  passwordLevel0: '低',
  passwordLevel1: '低',
  passwordLevel2: '中',
  passwordLevel3: '强',
  passwordTips: '请输入 8-16 位密码。请不要使用容易被猜到的密码。',
  passwordWarn: '密码强度不够！',

  repasswordTxt: '确认密码',
  repasswordBlank: '请确认密码！',
  repasswordWarn: '两次密码输入不一致！',

  varifyCodeTxt: '验证码', 
  varifyCodeBlank: '请输入验证码！',
  varifyCodeSending: '验证码发送中...',
  varifyCodeSendSuccess: '验证码发送成功！',
  varifyCodeSendFail: '验证码发送失败！',  

  changePasswordSuccess: '修改密码成功',
  changePasswordSuccessBrief: '请牢记新密码，不要再搞忘了哟(＾Ｕ＾)ノ~ＹＯ！',
  changePasswordFail: '修改密码失败！',

  varifyCodeBtn: '获取验证码',
  backLoginBtn: '返回登录',
  changePasswordBtn: '修改密码'
}
const enUS = {
  changePassword: 'Change Password',

  usernameTxt: 'Username',
  usernameBlank: 'Username can\'t be blank!',
  usernameVaildFail: ' Username verification failed!',

  passwordTxt: 'Password',
  passwordBlank: 'Fill in 8-16 password, case sensitive!',
  
  passwordStrength: 'Strength',
  passwordLevel0: 'Low',
  passwordLevel1: 'Low',
  passwordLevel2: 'Medium',
  passwordLevel3: 'Advanced',
  passwordTips: 'Please enter 8-16 bit password. Don\'t use easily guessed passwords.',
  passwordWarn: 'Password strength not enough!',

  repasswordTxt: 'Confirm Password',
  repasswordBlank: 'Please confirm the password!',
  repasswordWarn: 'Two inconsistent password entries!',

  varifyCodeTxt: 'Verification Code', 
  varifyCodeBlank: 'Verification Code can\'t be blank!',
  varifyCodeSending: 'Verification code sending...',
  varifyCodeSendSuccess: 'Send verification code successfully!',
  varifyCodeSendFail: 'Send verification code failed!', 

  changePasswordSuccess: 'Change the password successfully',
  changePasswordSuccessBrief: 'Please remember the new password and don\'t forget it！',
  changePasswordFail: 'Modify password failed!',

  varifyCodeBtn: 'Get Code',
  backLoginBtn: 'Back Login',
  changePasswordBtn: 'Change Password'
}

export default { zhCN, enUS }